module.exports = __webpack_public_path__ + "media/svg/CameraVideoFill-f8f7ea6d.svg";